
import { ArrowBigRight, UserRoundIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { EstablishmentUserData } from "../types/establishmentUsers.type";
import { userStatusTranslation } from "../constants/userStatus.constant";
import ImageWithDisplayName from "../components/ImageWithDisplayName";
import { formatDateTime } from "@/common/utils/formatters";

export class EstablishmentUsersTransformer {
  static tableTransformer({ establishmentId }: { establishmentId: string; }) {
    return (establishmentUsers: EstablishmentUserData[]) => {
      return establishmentUsers.map((establishmentUser) => ({
        ...establishmentUser,
        full_name_with_profile_picture: (
          <ImageWithDisplayName
            placeholderIcon={UserRoundIcon}
            imageUrl={establishmentUser.profile_picture?.url}
            displayName={establishmentUser.full_name}
          />
        ),
        user_role: !!establishmentUser?.user_roles?.length ? (establishmentUser?.user_roles?.map((userRole) => userRole.role.display_name).join(', ') || 'Não informado') : 'Não informado',
        lastSeenAt: establishmentUser?.last_seen_at ? formatDateTime(new Date(establishmentUser?.last_seen_at)) : "",
        status: userStatusTranslation[(establishmentUser?.status || 'default') as keyof typeof userStatusTranslation],
        actions: <Link to={`/establishments/${establishmentId}/users/${establishmentUser.id}`} data-testid="access_establishment_user_button"><ArrowBigRight /></Link>
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (users: EstablishmentUserData[]) => {
      return users.map((user) => ({
        route: `establishments/${user.company_id}/users/${user.id}`,
        items: [
          ['Perfil', !!user?.user_roles?.length && (user?.user_roles?.map((userRole) => userRole.role.display_name).join(', '))],
          ['Nome', user.full_name],
          ['Estabelecimento', user?.company_branch?.general_information?.fantasy_name || user?.company_branch?.general_information?.official_name],
          ['Filial', user?.company_branch?.display_name],
        ],
      }));
    };
  }
}
